import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Textfield from "../Input/Textfield";
import { DeliveryMethods } from "@/shared/utils/enum";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import { useIsFetching } from "@tanstack/react-query";
import useBranchId from "@/shared/hooks/useBranchId";
import Spinner from "../Spinner/Spinner";
import usePosOrderUser from "@/shared/atoms/usePosOrderUser";
import usePosSettingsHook from "@/shared/hooks/usePosSettingsHook";
import useCountryConfigHook from "@/shared/hooks/useCountryConfigHook";

const Street = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();
  const { register, errors, getValues } = useFormContext();
  const [orderUser] = usePosOrderUser();
  const [deliveryMethodId] = usePosOrderDeliveryMethod();
  const values = getValues();
  const { zip_code, house_number } = values.order_user ?? {};
  const {
    settings: { accept_all_addresses },
  } = usePosSettingsHook();
  const { isTurkiye } = useCountryConfigHook();

  const isFetching = useIsFetching({
    queryKey: ["zipcode", branchId, zip_code, house_number],
  });
  const isRequiredForDelivery =
    deliveryMethodId === DeliveryMethods.DELIVERY && !accept_all_addresses;

  return (
    <Textfield
      ref={register({
        required: {
          value: isRequiredForDelivery,
          message: t("fieldRequired"),
        },
      })}
      isRequired={isRequiredForDelivery}
      defaultValue={orderUser?.street_name}
      error={errors.order_user?.street_name?.message}
      label={isTurkiye ? t("posOrders.avenueAndStreet") : t("posOrders.street")}
      name="order_user.street_name"
      inputRightAddon={isFetching ? <Spinner size="0.18rem" /> : null}
    />
  );
};

export default Street;
